import { Fragment } from "react";
import clsx from "clsx";
import ContentLayouts from "layouts/ContentLayouts";
import { QuestionText } from "components/atoms/Text";

const Content = () => {
    return (
        <Fragment>
            <header className={clsx(
                "w-full max-w-[1440px] mx-auto relative",
                "px-6 tablet:px-8 desktop:px-[120px]",
                "phone:pt-12 phone:pb-14 tablet:py-16 desktop:pt-20 desktop:pb-[104px]",
                "bg-neutral-10"
            )}>
                <ContentLayouts>
                    <QuestionText>Since our website is offering intangible goods refunds are honored for the following reasons:</QuestionText>
                    <div className="ml-6">
                        <li className="font-semibold text-lg phone:leading-[27.2px] leading-[30.6px] text-neutral-100 pt-3">
                            Non-delivery of the product: in case we fail to deliver the purchased goods you are entitled for a full refund.
                        </li>
                        <li className="font-semibold text-lg phone:leading-[27.2px] leading-[30.6px] text-neutral-100">
                            Service issues: in case our service is not functioning as advertised you are entitled for a full refund
                        </li>
                    </div>
                    <QuestionText classNames="py-3">Please note that we do not bear any responsibility and therefore we do not satisfy any refund/return/exchange requests based on incompatibility of our products with some third-party software (plug-ins, add-ons, modules, search engines, scripts, extensions etc). We don't guarantee that our products are fully compatible with any third-party programs and we do not provide support for third-party applications.</QuestionText>
                    <QuestionText>Our Technical Support Team is always eager to assist you and deliver highly professional support in a timely manner.</QuestionText>
                </ContentLayouts>
            </header>
            <p></p>
        </Fragment >
    );
};

export default Content;